"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Rychle prihlaseni v Marbesu pomoci univerzalniho hesla Generated from cz.marbes.react.MarbesAuthController.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-06-17T17:57:00Z                      #

// ##############################################################

var MarbesAuthApi = function () {
  function MarbesAuthApi() {
    (0, _classCallCheck3.default)(this, MarbesAuthApi);
  }

  (0, _createClass3.default)(MarbesAuthApi, null, [{
    key: "isOpenIdConfigured",

    /**
     * Zjištění zda je Openid nakonfigurované.
     *
     * @return TRUE - je nokonfigurovaní openId
     */
    value: function isOpenIdConfigured() {
      var uri = serverContextPath + "/api/auth/isopenidconfigured";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * 
     *
     */

  }, {
    key: "logout",
    value: function logout() {
      var uri = serverContextPath + "/api/auth/logout";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param credentials 
     * @return 
     */

  }, {
    key: "login",
    value: function login(credentials) {
      var uri = serverContextPath + "/api/auth/login";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, credentials, headers));
    }

    /**
     * Přihlášení pomocí OpenId. Po tomto volání je nutné na klientovy udělat refresh stránky!
     *
     * @return 
     */

  }, {
    key: "loginByOpenId",
    value: function loginByOpenId() {
      var uri = serverContextPath + "/api/auth/loginbyopenid";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Zjištění zda lze použít NTLM.
     *
     * @return TRUE - lze použít NTLM
     */

  }, {
    key: "canUseNtlm",
    value: function canUseNtlm() {
      var uri = serverContextPath + "/api/auth/canusentlm";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * 
     *
     * @return 
     */

  }, {
    key: "check",
    value: function check() {
      var uri = serverContextPath + "/api/auth/check";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param redir 
     */

  }, {
    key: "ntlm",
    value: function ntlm(redir) {
      var uri = serverContextPath + "/api/auth/ntlm";
      var headers = undefined;
      var params = { redir: redir };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }
  }]);
  return MarbesAuthApi;
}();

exports.default = MarbesAuthApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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